import { stationLabel } from './playlistDelivery';

// A station repeats its import state each minute while it has one to show, so
// a report older than this means the station went quiet (offline, quit).
export const IMPORT_STATE_STALE_MS = 5 * 60 * 1000;

export const IMPORT_QUEUE_STATE_TYPE = 'import_queue_state';

const STATUSES = ['ready', 'waiting', 'imported'];

const defaultFormatTime = (iso) => new Date(iso).toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' });

/**
 * The station strip for ProPresenter 22 imports (ms-pp21-22 plan §2.6, L4):
 * one row per station whose latest `import_queue_state` is fresh. Stations in
 * legacy drop mode never send that message, so they never get a row.
 */
export function stationImportStrips(stationImports, linkedAgents, { now = Date.now(), formatTime = defaultFormatTime } = {}) {
  return Object.entries(stationImports ?? {})
    .filter(([, report]) => STATUSES.includes(report?.status) && now - Date.parse(report.at) <= IMPORT_STATE_STALE_MS)
    .map(([agentId, report]) => {
      const station = stationLabel(linkedAgents, agentId);
      const base = { agentId, station, status: report.status, name: report.name ?? '' };
      if (report.status === 'imported') {
        return { ...base, primary: `Imported on ${station} at ${formatTime(report.importedAt)}`, importNow: null };
      }
      const count = report.pendingCount ?? 1;
      return {
        ...base,
        primary: report.status === 'waiting' ? 'Waiting for you in ProPresenter' : `Ready on ${station}`,
        detail: report.status === 'waiting'
          ? `${base.name} on ${station}`
          : `${base.name}: open Media Station and press Import now, or press it here on the ProPresenter computer.`,
        importNow: { label: `Import now (${count})`, enabled: report.canImportNow === true },
      };
    });
}

export function importNowErrorMessage(error, station) {
  if (error?.status === 404) return `Press Import now in Media Station on ${station}.`;
  if (error?.status === 401) return 'Session expired. Please sign in again.';
  return `Could not reach ${station}. Press Import now in Media Station there.`;
}
